import React from 'react';
import _ from 'lodash';
import { FormControl, TextField, Typography } from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useDebouncedCallback } from 'use-debounce';

import { RequiredField } from '../others/RequiredField';
import { useDynamicFunction } from '../../services/hooks';
import { formatDate } from '../../services/functions';
import { InfoField } from './InfoField';
import { CssTextField } from '../others/CssTextField';

export const DateField = props => {
  const { field, formik, getFieldCallback } = props;
  const dynamicFunction = useDynamicFunction(field.on_change);
  const debounced = useDebouncedCallback(
    val => {
      if (!_.isNil(dynamicFunction)) {
        if (dynamicFunction.functionName === 'setEmptyChoicesFunction') {
          const newObjects = {};
          _.forEach(dynamicFunction.data, item => {
            newObjects[item] = '';
          });
          newObjects[field.name] = formatDate(val);
          formik.setValues({ ...formik.values, ...newObjects });
          // _.forEach(dynamicFunction.data, item => formik.setFieldValue(item, ''));
        }
      } else {
        formik.setFieldValue(field.name, formatDate(val));
      }
    },
    200
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} >
      <FormControl style={{ paddingBottom: 15 }} fullWidth>
        <Typography variant="subtitle1" style={{ paddingBottom: 15 }}>
          <b>{field.label}</b>
          <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} />
        </Typography>
        <DatePicker
          inputFormat="yyyy-MM-dd"
          mask="____-__-__"
          autoOk
          name={field.name}
          label={_.isEmpty(formik.values[field.name]) ? field.placeholder : null}
          value={formik.values[field.name]}
          onChange={val => debounced(val)}
          error={
            formik.touched[field.name] && Boolean(formik.errors[field.name])
          }
          helperText={formik.touched[field.name] && formik.errors[field.name]}
          renderInput={props => <CssTextField variant="outlined" {...props} />}
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
        />
        {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
            : null
        }
      </FormControl>
    </LocalizationProvider>
  );
};
